
import { defineComponent } from 'vue';
import Form from '@/shared/mixins/Form';
import { required, minLength, sameAs } from '@vuelidate/validators';
import { accountService } from './AccountService';
import useVuelidate from '@vuelidate/core';

export default defineComponent({
  name: 'ResetPassword',
  mixins: [Form],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      form: {
        code: '',
        userId: '',
        password: '',
        confirmPassword: '',
      },
    };
  },
  validations() {
    return {
      form: {
        password: { required, minLength: minLength(8) }, // https://jsfiddle.net/sg2zd9mf/
        confirmPassword: { required, sameAsPassword: sameAs(this.form.password) },
      },
    };
  },
  methods: {
    async send() {
      this.form.userId = this.$route.query.userId as string;
      this.form.code = this.$route.query.code as string;

      if (!this.validate()) return;

      try {
        await accountService.resetPassword(this.form);
        this.success();
      } catch (error) {
        this.handleApiError(error);
      }
    },
  },
});
